import { IApiVisitResult } from 'affiny-core/modules/api/models/interactions/visits/visit.types';
import { paginatedRequest } from 'affiny-core/modules/helpers';
import { EAffinyEventOrigin } from '../affiny.eventorigins';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const VisitsResource = {
  postVisit: (myAccountId: string, otherAccountId: string) =>
    AffinyEndpoint.Visit.url(`/${myAccountId}/${otherAccountId}`)
      .headers({ 'X-Event-Origin': EAffinyEventOrigin.W_PVIEW_DISPLAY })
      .post()
      .res(),
  getVisits: (accountId: string, pageNumber: number, pageSize: number) =>
    paginatedRequest<IApiVisitResult>({
      apiEndPoint: AffinyEndpoint.Visits.url(`/${accountId}/`),
      pageNumber,
      pageSize,
    }),
};
